import {api} from './api'
import thunkMiddleware from 'redux-thunk'
import {applyMiddleware} from 'redux'
import dynamicMiddlewares from 'redux-dynamic-middlewares'
import {toastify} from './toastify'
import {changes} from './changes'

export default applyMiddleware(thunkMiddleware, api, changes, toastify, dynamicMiddlewares)
